import React from 'react';
import Header from './Header';
import Footer from './Footer';
import { Helmet } from 'react-helmet-async';
import logo from '../assets/img/logo/logo_low.png';

const Alerts = () => {
  // Alert groups data
  const itGroups = [
    { id: 1, name: 'Fresher Job Adda Group 1', type: 'whatsapp', category: 'it', link: 'https://chat.whatsapp.com/FUlOD1Yl39A8C8BbYqetQt' },
    { id: 2, name: 'Fresher Job Adda Group 2', type: 'whatsapp', category: 'mba', link: 'https://chat.whatsapp.com/IfT5nx0YlscAhC5cgpZqmV' },
    { id: 3, name: 'Fresher Job Adda Group 3', type: 'whatsapp', category: 'all', link: 'https://chat.whatsapp.com/IXmwZhogcEm0CZo3plnMqk' },
   { id: 4, name: 'Fresher Job Adda Group 4', type: 'whatsapp', category: 'govt', link: 'https://chat.whatsapp.com/LPECJb4IhsFF6w5PvPIqbA' },
    { id: 5, name: 'Fresher Job Adda Group 5', type: 'whatsapp', category: 'govt', link: 'https://chat.whatsapp.com/JDQolEcS4hp6ArvYWLpf3z' },

  ];

  const govtGroups = [
    { id:1, name: 'Fresher Job Adda Group 6', type: 'whatsapp', category: 'it-experienced', link: 'https://chat.whatsapp.com/FyP582b70WS0rT1t1io66P' },

    { id: 2, name: 'Fresher Job Adda Group 7', type: 'whatsapp', category: 'non-it', link: 'https://chat.whatsapp.com/BBvFSe2lyFaK6Ut91puFz8' },
    { id: 3, name: 'Fresher Job Adda Group 8', type: 'whatsapp', category: 'technical', link: 'https://chat.whatsapp.com/GXCycm67guZC5mNC5uCLEN' },

    { id: 4, name: 'Fresher Job Adda Group 9', type: 'whatsapp', category: 'it', link: 'https://chat.whatsapp.com/LZS5hDldmvGL9P5aBqxW3B' },

  ];

  const otherGroups = [
   
    { id: 3, name: 'Fresher Job Adda Group 10', type: 'whatsapp', category: 'general', link: 'https://chat.whatsapp.com/LRtsstBuQCi3y89K5EmZ7P' }
  ];

  return (
    <>
      <Helmet>
        <title>Job Alerts | Fresher Job Adda</title>
        <meta name="description" content="Join our WhatsApp and Telegram groups for latest job updates" />
      </Helmet>
 
      <Header />
      
      <div className="container pt-5" style={{  minHeight: '100vh' }}>
        
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-12">
            
              <div className="card-body p-4 text-center">
  {/* Header Section */}
  <img 
    src={logo} 
    alt="Fresher Job Adda Logo" 
    style={{ 
      width: '180px', 
      height: 'auto',
      marginBottom: '20px',
      filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))'
    }} 
  />
  <h4 className="mt-3 mb-2">Fresher Job Adda WhatsApp Groups</h4>
  <p className="text-muted mb-4">Join our WhatsApp groups to get instant job notifications</p>


  

  
  {/* All Groups Section */}
  <div className="text-start mt-4">
    <div className="row">
      {itGroups.map((group) => (
        <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-3" key={`it-${group.id}`}>
          <a 
            href={group.link}
            target="_blank"
            rel="noopener noreferrer" 
            className="d-block alert alert-success text-decoration-none h-100 position-relative"
            style={{ 
              borderRadius: '8px',
              padding: '5px',
              transition: 'transform 0.2s',
              boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
              hover: {
                transform: 'translateY(-2px)',
                boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
              }
            }}
          >
            <div className="d-flex align-items-center">
              <div className="me-3">
                <img 
                  src={logo} 
                  alt="Group Logo" 
                  style={{ 
                    width: '45px',
                    height: '45px',
                    objectFit: 'contain',
                    borderRadius: '8px',
                    padding: '4px',
                    backgroundColor: '#fff',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                  }} 
                />
              </div>
              <div>
                <div className="fw-bold mb-1">{group.name}</div>
              
              </div>
            </div>
          </a>
        </div>
      ))}
    </div>
  </div>
  
  {/* Government Groups */}
  <div className="text-start mt-4">
    <div className="row">
      {govtGroups.map((group) => (
        <div className="col-12 col-sm-6 col-md-4 col-lg-3 " key={`govt-${group.id}`}>
          <a 
            href={group.link}
            target="_blank"
            rel="noopener noreferrer" 
            className="d-block alert alert-warning text-decoration-none h-100 position-relative"
            style={{ 
              borderRadius: '8px',
              padding: '5px',
              transition: 'transform 0.2s',
              boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
            }}
          >
            <div className="d-flex align-items-center">
              <div className="me-3">
                <img 
                  src={logo} 
                  alt="Group Logo" 
                  style={{ 
                    width: '45px',
                    height: '45px',
                    objectFit: 'contain',
                    borderRadius: '8px',
                    padding: '4px',
                    backgroundColor: '#fff',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                  }} 
                />
              </div>
              <div>
                <div className="fw-bold mb-1">{group.name}</div>
               
              </div>
            </div>
          </a>
        </div>
      ))}
    </div>
  </div>
  
  {/* Other Groups */}
  <div className="text-start mt-4">
    <div className="row">
      {otherGroups.map((group) => (
        <div className="col-12 col-sm-6 col-md-4 col-lg-3 " key={`other-${group.id}`}>
          <a 
            href={group.link}
            target="_blank"
            rel="noopener noreferrer" 
            className="d-block alert alert-info text-decoration-none h-100 position-relative"
            style={{ 
              borderRadius: '8px',
              padding: '5px',
              transition: 'transform 0.2s',
              boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
            }}
          >
            <div className="d-flex align-items-center">
              <div className="me-3">
                <img 
                  src={logo} 
                  alt="Group Logo" 
                  style={{ 
                    width: '45px',
                    height: '45px',
                    objectFit: 'contain',
                    borderRadius: '8px',
                    padding: '4px',
                    backgroundColor: '#fff',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                  }} 
                />
              </div>
              <div>
                <div className="fw-bold mb-1">{group.name}</div>
             
              </div>
            </div>
          </a>
        </div>
      ))}
    </div>
  </div>


              </div>
            </div>
          </div>
        
      </div>

      <Footer />

      <style jsx>{`
        .alert {
          transition: all 0.3s ease;
          border: 1px solid rgba(0,0,0,0.1);
        }

        .alert:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0,0,0,0.1);
        }

        .alert img {
          transition: transform 0.3s ease;
        }

        .alert:hover img {
          transform: scale(1.05);
        }

        .text-success {
          color: #25D366 !important;
        }
      `}</style>
    </>
  );
};

export default Alerts; 